"use client";
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { RadioButton } from "../../actions/selectionControls/RadioButton.js";
import { SelectionCardLoader, SelectionCardContent } from "./internal/SelectionCard.js";
import { InfoCard } from "./InfoCard.js";
import { forwardRef } from "react";
import { StyledCardRecipe } from "./checkboxCard.css.js";
import classNames from "classnames";
const RadioCard = forwardRef(function RadioCard2({ label, description, value, id, name, onChange, children, isLoading, validity, cardStyle, ...props }, ref) {
  return jsx(InfoCard, { ref, ...props, className: classNames(StyledCardRecipe({
    disabled: props.disabled,
    cardStyle: cardStyle ?? "elevation"
  }), props.className), children: isLoading ? jsx(SelectionCardLoader, { type: "radio", density: props.density }) : jsxs(Fragment, { children: [jsx(RadioButton, { label, value, onChange, disabled: props.disabled, validity, id, name }), jsx(SelectionCardContent, { description, value, density: props.density, children })] }) });
});
export {
  RadioCard
};
